import { z } from 'zod/v4'

export const userTaxValidation = () => {
  return z.object({
    type_of_bussines: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    id_type: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    registered_vat: z.string().optional().or(z.literal('')).nullable(),
    taxes_name: z.string().min(1, { message: 'Form is required' }),
    taxes_address: z.string().min(1, { message: 'Form is required' }),
    taxes_id: z.string().optional().or(z.literal('')).nullable(),
    identity_card: z.string().optional().or(z.literal('')).nullable(),
    company_name: z.string().optional().or(z.literal('')).nullable(),
    company_country: z.string().optional().or(z.literal('')).nullable(),
    new_company_logo: z.string().optional().or(z.literal('')).nullable(),
  }).refine(
    (data) => {
      if (data.id_type === 'NPWP') {
        return data.registered_vat !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['registered_vat'],
    }
  ).refine(
    (data) => {
      if (data.id_type === 'NPWP') {
        return data.taxes_id !== null && data.taxes_id !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['taxes_id'],
    }
  ).refine(
    (data) => {
      if (data.id_type === 'KTP') {
        return data.identity_card !== null && data.identity_card !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['identity_card'],
    }
  ).refine(
    (data) => {
      if (data.type_of_bussines === 'business') {
        return data.company_name !== null && data.company_name !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['company_name'],
    }
  ).refine(
    (data) => {
      if (data.type_of_bussines === 'business') {
        return data.company_country !== null && data.company_country !== ''
      }
      return true
    }, {
      message: 'Form is required',
      path: ['company_country'],
    }
  )
}